import { render, staticRenderFns } from "./balances-table.vue?vue&type=template&id=aaba5a16&"
import script from "./balances-table.vue?vue&type=script&lang=ts&"
export * from "./balances-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports